export default "__VITE_ASSET__DsVKNiAL__"